import React, { useState, useEffect, createContext } from "react";
import { useHistory, useLocation } from "react-router-dom";
const TicketsContext = createContext();
const TicketsContextProvider = ({ children }) => {
        const [currentTicket, setCurrentTicket] = useState({ id: null, code: null });
        const [tabOpen, setTabOpen] = useState("open");
        const history = useHistory();
        const location = useLocation();
        useEffect(() => {
                if (currentTicket.id !== null && currentTicket.uuid) {
                        const targetPath = `/tickets/${currentTicket.uuid}`;
                        if (location.pathname !== targetPath) {
                                history.push(targetPath);
                        }
                }
        }, [currentTicket, history]) // eslint-disable-line react-hooks/exhaustive-deps -- so deve navegar quando um NOVO ticket e selecionado, nao a cada mudanca de rota
        return (
                <TicketsContext.Provider
                        value={{ currentTicket, setCurrentTicket, tabOpen, setTabOpen }}
                >
                        {children}
                </TicketsContext.Provider>
        );
};
export { TicketsContext, TicketsContextProvider };
